import { Repository } from "./repository";
const securityRepo = {
  login,  
};
const resource = "Security";

function login(payLoad) {
  return Repository().post(`${resource}/login/`, payLoad);
}


export default securityRepo